// ** React Imports
import { useState, createContext, useCallback } from 'react'


// ** Create Context
const Context = createContext()

const EntityContextProvider = ({ children }) => {
  // ** States
  const [selectedEntity, setSelectedEntity] = useState(null)

  const onEntityChange = useCallback((entity) => {
    setSelectedEntity(entity)
    // setTheme(prevTheme => (prevTheme === themes.dark ? themes.light : themes.dark));
  }, []); // Memoize the function to prevent unnecessary re-renders in consumers

  
  // ----------------------------------------------------------------------------------------------------------------------------------
  // // ** on entity drp change
  // const onEntityChange = (entity) => {
  //   setSelectedEntity(entity)
  // }


  return (
    <Context.Provider value={{ selectedEntity: selectedEntity, onEntityChange: onEntityChange}}>
      {children}
    </Context.Provider>
  )
}

export { EntityContextProvider, Context as EntityContext }
